import React, { useState, useEffect } from 'react';
import { TextField } from '@rmwc/textfield';
import '@rmwc/textfield/styles';
import { RCTooltip } from '@rmwc/rc-tooltip';
import '@rmwc/rc-tooltip/styles';
import ResetDB from './ResetDB';
import './DCalc.css';
import * as calcs from '../Formeln';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';

import EinStarr from '../assets/EinStarr.png';
import ZweiAuf from '../assets/ZweiAuf.png';
import ZweiStarr from '../assets/ZweiStarr.png';
import KraftAufrecht from '../assets/KraftAufrecht.png';
import KraftLiegend from '../assets/KraftLiegend.png';
import Senkrecht from '../assets/Senkrecht.png';
import EinDrehung from '../assets/EinDrehung.png';
import ZweiDrehung from '../assets/ZweiDrehung.png';

function Calculation() {
  const SelectedProfile = useFlexionStore((state) => state.SelectedProfile);
  const SelectedProfileFetched = useFlexionStore((state) => state.SelectedProfileFetched);
  const Länge = useFlexionStore((state) => state.Länge);
  const setLänge = useFlexionStore((state) => state.setLänge);
  const Punktlast = useFlexionStore((state) => state.Punktlast);
  const setPunktlast = useFlexionStore((state) => state.setPunktlast);
  const Streckenlast = useFlexionStore((state) => state.Streckenlast);
  const setStreckenlast = useFlexionStore((state) => state.setStreckenlast);
  const b = useFlexionStore((state) => state.b);
  const setb = useFlexionStore((state) => state.setb);
  const Mt = useFlexionStore((state) => state.Mt);
  const setMt = useFlexionStore((state) => state.setMt);
  const ProfilesFetched = useFlexionStore((state) => state.ProfilesFetched);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [Sicherheitsfaktor, setSicherheitsfaktor] = useState(5);
  const [text, setText] = useState(getText(Sprache));

  useEffect(() => {
    setText(getText(Sprache));
  }, [Sprache]);

  function handleLänge(e) {
    if (e.target.value > 99999) {
      setLänge(Länge);
      return;
    }
    setLänge(e.target.value);
  }

  function handlePunkt(e) {
    setPunktlast(e.target.value);
  }

  function handleVerteilt(e) {
    setStreckenlast(e.target.value);
  }

  function handleb(e) {
    setb(e.target.value);
  }

  function handleMt(e) {
    setMt(e.target.value);
  }

  function handleSicherheit(e) {
    setSicherheitsfaktor(e.target.value);
  }

  function EigenEinStarrHoch() {
    return calcs.EigenEinStarrHoch(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Iy
    );
  }

  function VertEinStarrHoch() {
    return calcs.VertEinStarrHoch(Streckenlast, Länge, SelectedProfile.E, SelectedProfile.Iy);
  }

  function PunktEinStarrHoch() {
    return calcs.PunktEinStarrHoch(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Iy);
  }

  function EinStarrHochGesamt() {
    const erg = PunktEinStarrHoch() + VertEinStarrHoch() + EigenEinStarrHoch();
    return Math.round(erg * 100) / 100;
  }

  function EinStarrHochZwang() {
    let StreckenlastNum = parseFloat(Streckenlast);
    if (Number.isNaN(StreckenlastNum)) {
      StreckenlastNum = 0;
    }
    return calcs.EinStarrHochZwang(
      Punktlast,
      Länge,
      StreckenlastNum,
      SelectedProfile.Lineargewicht,
      SelectedProfile.Iy,
      SelectedProfile.X
    );
  }

  function EigenEinStarrQuer() {
    return calcs.EigenEinStarrQuer(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Ix
    );
  }

  function VertEinStarrQuer() {
    return calcs.VertEinStarrQuer(Streckenlast, Länge, SelectedProfile.E, SelectedProfile.Ix);
  }

  function PunktEinStarrQuer() {
    return calcs.PunktEinStarrQuer(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Ix);
  }

  function EinStarrQuerGesamt() {
    const erg = PunktEinStarrQuer() + VertEinStarrQuer() + EigenEinStarrQuer();
    return Math.round(erg * 100) / 100;
  }

  function EinStarrQuerZwang() {
    let StreckenlastNum = parseFloat(Streckenlast);
    if (Number.isNaN(StreckenlastNum)) {
      StreckenlastNum = 0;
    }
    return calcs.EinStarrQuerZwang(
      Punktlast,
      Länge,
      StreckenlastNum,
      SelectedProfile.Lineargewicht,
      SelectedProfile.Ix,
      SelectedProfile.Y
    );
  }

  function EigenAufHoch() {
    return calcs.EigenAufHoch(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Iy
    );
  }

  function VertAufHoch() {
    return calcs.VertAufHoch(Streckenlast, Länge, SelectedProfile.E, SelectedProfile.Iy);
  }

  function PunktAufHoch() {
    return calcs.PunktAufHoch(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Iy);
  }

  function AufHochGesamt() {
    const erg = EigenAufHoch() + VertAufHoch() + PunktAufHoch();
    return Math.round(erg * 100) / 100;
  }

  function AufHochZwang() {
    let StreckenlastNum = parseFloat(Streckenlast);
    if (Number.isNaN(StreckenlastNum)) {
      StreckenlastNum = 0;
    }
    return calcs.AufHochZwang(
      Punktlast,
      Länge,
      StreckenlastNum,
      SelectedProfile.Lineargewicht,
      SelectedProfile.Iy,
      SelectedProfile.X
    );
  }

  function EigenAufQuer() {
    return calcs.EigenAufQuer(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Ix
    );
  }

  function VertAufQuer() {
    return calcs.VertAufQuer(Streckenlast, Länge, SelectedProfile.E, SelectedProfile.Ix);
  }

  function PunktAufQuer() {
    return calcs.PunktAufQuer(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Ix);
  }

  function AufQuerGesamt() {
    const erg = EigenAufQuer() + VertAufQuer() + PunktAufQuer();
    return Math.round(erg * 100) / 100;
  }

  function AufQuerZwang() {
    let StreckenlastNum = parseFloat(Streckenlast);
    if (Number.isNaN(StreckenlastNum)) {
      StreckenlastNum = 0;
    }
    return calcs.AufQuerZwang(
      Punktlast,
      Länge,
      StreckenlastNum,
      SelectedProfile.Lineargewicht,
      SelectedProfile.Ix,
      SelectedProfile.Y
    );
  }

  function EigenZweiStarrHoch() {
    return calcs.EigenZweiStarrHoch(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Iy
    );
  }

  function VertZweiStarrHoch() {
    return calcs.VertZweiStarrHoch(Streckenlast, Länge, SelectedProfile.E, SelectedProfile.Iy);
  }

  function PunktZweiStarrHoch() {
    return calcs.PunktZweiStarrHoch(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Iy);
  }

  function ZweiStarrHochGesamt() {
    const erg = PunktZweiStarrHoch() + VertZweiStarrHoch() + EigenZweiStarrHoch();
    return Math.round(erg * 100) / 100;
  }

  function ZweiStarrHochZwang() {
    let StreckenlastNum = parseFloat(Streckenlast);
    if (Number.isNaN(StreckenlastNum)) {
      StreckenlastNum = 0;
    }
    return calcs.ZweiStarrHochZwang(
      Punktlast,
      StreckenlastNum,
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.Iy,
      SelectedProfile.X
    );
  }

  function EigenZweiStarrQuer() {
    return calcs.EigenZweiStarrQuer(
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.E,
      SelectedProfile.Ix
    );
  }

  function VertZweiStarrQuer() {
    return calcs.VertZweiStarrQuer(Streckenlast, Länge, SelectedProfile.E, SelectedProfile.Ix);
  }

  function PunktZweiStarrQuer() {
    return calcs.PunktZweiStarrQuer(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Ix);
  }

  function ZweiStarrQuerGesamt() {
    const erg = PunktZweiStarrQuer() + VertZweiStarrQuer() + EigenZweiStarrQuer();
    return Math.round(erg * 100) / 100;
  }

  function ZweiStarrQuerZwang() {
    let StreckenlastNum = parseFloat(Streckenlast);
    if (Number.isNaN(StreckenlastNum)) {
      StreckenlastNum = 0;
    }
    return calcs.ZweiStarrQuerZwang(
      Punktlast,
      StreckenlastNum,
      SelectedProfile.Lineargewicht,
      Länge,
      SelectedProfile.Ix,
      SelectedProfile.Y
    );
  }

  function SenkStarrHoch() {
    return calcs.SenkStarrHoch(Punktlast, b, Länge, SelectedProfile.E, SelectedProfile.Iy);
  }

  function SenkStarrHochZwang() {
    return calcs.SenkStarrHochZwang(b, Punktlast, SelectedProfile.Iy, SelectedProfile.X);
  }

  function SenkStarrQuer() {
    return calcs.SenkStarrQuer(Punktlast, b, Länge, SelectedProfile.E, SelectedProfile.Ix);
  }

  function SenkStarrQuerZwang() {
    return calcs.SenkStarrQuerZwang(b, Punktlast, SelectedProfile.Ix, SelectedProfile.Y);
  }

  function EinDreh() {
    if (Number.isNaN(parseFloat(SelectedProfile.It))) {
      return 0;
    }
    return calcs.EinDreh(Mt, Länge, SelectedProfile.G, SelectedProfile.It);
  }

  function EinDrehZwang() {
    if (Number.isNaN(parseFloat(SelectedProfile.It))) {
      return 0;
    }
    return calcs.EinDrehZwang(
      Mt,
      calcs.PunktEinStarrQuer(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Ix),
      SelectedProfile.Iy,
      SelectedProfile.X
    );
  }

  function ZweiDreh() {
    if (Number.isNaN(parseFloat(SelectedProfile.It))) {
      return 0;
    }
    return calcs.ZweiDreh(Mt, Länge, SelectedProfile.G, SelectedProfile.It);
  }

  function ZweiDrehZwang() {
    if (Number.isNaN(parseFloat(SelectedProfile.It))) {
      return 0;
    }
    return calcs.ZweiDrehZwang(
      Mt,
      calcs.PunktEinStarrQuer(Punktlast, Länge, SelectedProfile.E, SelectedProfile.Ix),
      SelectedProfile.Ix,
      SelectedProfile.Y
    );
  }

  function SicherheitsfaktorSymbol(func) {
    const spannung = func();
    if (spannung >= SelectedProfile['Rp0,2'] / Sicherheitsfaktor) {
      if (spannung <= SelectedProfile['Rp0,2']) {
        return '!';
      }
      return 'X';
    }
    return '';
  }

  function ClassNames(func, mode) {
    let val = 0;
    let coef = 0;
    if (ProfilesFetched) val = func();
    if (mode === 1) coef = 200;
    else if (mode === 2) coef = 250;
    else if (mode === 3) coef = 300;
    if (val > Länge / coef) {
      return ' Limit';
    }
    return '';
  }

  return (
    <>
      <div className='DCalcInput'>
        <RCTooltip
          open={parseFloat(Länge, 10) < 0}
          showArrow
          align='bottom'
          content={text.DCalc ? text.DCalc.LessThan0Tooltip : ' '}
        >
          <TextField
            label={text.DCalc ? text.DCalc.LInput : ' '}
            type='number'
            value={Länge}
            onChange={handleLänge}
            className='Input'
            onFocus={(e) => {
              e.target.select();
            }}
          />
        </RCTooltip>
        <RCTooltip
          open={parseFloat(Punktlast, 10) < 0}
          showArrow
          align='bottom'
          content={text.DCalc ? text.DCalc.LessThan0Tooltip : ' '}
        >
          <TextField
            label={text.DCalc ? text.DCalc.PInput : ' '}
            type='number'
            value={Punktlast}
            onChange={handlePunkt}
            className='Input'
            onFocus={(e) => {
              e.target.select();
            }}
          />
        </RCTooltip>
        <RCTooltip
          open={parseFloat(Streckenlast, 10) < 0}
          showArrow
          align='bottom'
          content={text.DCalc ? text.DCalc.LessThan0Tooltip : ' '}
        >
          <TextField
            label={text.DCalc ? text.DCalc.SInput : ' '}
            type='number'
            value={Streckenlast}
            onChange={handleVerteilt}
            className='Input'
            onFocus={(e) => {
              e.target.select();
            }}
          />
        </RCTooltip>
        <TextField
          label={text.DCalc ? text.DCalc.Safety : ' '}
          type='number'
          min='1'
          step='1'
          value={Sicherheitsfaktor}
          onChange={handleSicherheit}
          className='Input'
          style={{marginRight: '10px'}}
          onFocus={(e) => {
            e.target.select();
          }}
        />
        <div className='ResetDB'>
          <ResetDB />
        </div>
      </div>
      <div className='CalcTable'>
        <table>
          <thead>
            <tr>
              <th colSpan='2' className='TableTitle'>
                {text.DCalc ? text.DCalc.DB : ''}
              </th>
              <th>{text.DCalc ? text.DCalc.SelfDB : ''}</th>
              <th>{text.DCalc ? text.DCalc.DistDB : ''}</th>
              <th>{text.DCalc ? text.DCalc.SingleDB : ''}</th>
              <th>{text.DCalc ? text.DCalc.TotalDB : ''}</th>
              <th colSpan='2'>{text.DCalc ? text.DCalc.CurrStress : ''}</th>
              <th className='tooltip'>
                Rp0,2 %
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Yieldpoint : ''}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={`TopBorder${ClassNames(EinStarrHochGesamt, 1)}`}>
              <td rowSpan='2'>
                <img src={EinStarr} alt='Logo' />
              </td>
              <td className='tooltip'>
                <img src={KraftAufrecht} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Upright : ''}</span>
              </td>
              <td>{SelectedProfileFetched ? EigenEinStarrHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? VertEinStarrHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? PunktEinStarrHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? EinStarrHochGesamt() : '0'} mm</td>
              <td>{SelectedProfileFetched ? EinStarrHochZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(EinStarrHochZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((EinStarrHochZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
            <tr className={ClassNames(EinStarrQuerGesamt, 1)}>
              <td className='tooltip'>
                <img src={KraftLiegend} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Flat : ''}</span>
              </td>
              <td>{SelectedProfileFetched ? EigenEinStarrQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? VertEinStarrQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? PunktEinStarrQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? EinStarrQuerGesamt() : '0'} mm</td>
              <td>{SelectedProfileFetched ? EinStarrQuerZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(EinStarrQuerZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((EinStarrQuerZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
            <tr className={`TopBorder${ClassNames(AufHochGesamt, 2)}`}>
              <td rowSpan='2'>
                {' '}
                <img src={ZweiAuf} alt='Logo' />
              </td>
              <td className='tooltip'>
                <img src={KraftAufrecht} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Upright : ''}</span>
              </td>
              <td>{SelectedProfileFetched ? EigenAufHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? VertAufHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? PunktAufHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? AufHochGesamt() : '0'} mm</td>
              <td>{SelectedProfileFetched ? AufHochZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(AufHochZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((AufHochZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
            <tr className={ClassNames(AufQuerGesamt, 2)}>
              <td className='tooltip'>
                <img src={KraftLiegend} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Flat : ''}</span>
              </td>
              <td>{SelectedProfileFetched ? EigenAufQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? VertAufQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? PunktAufQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? AufQuerGesamt() : '0'} mm</td>
              <td>{SelectedProfileFetched ? AufQuerZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(AufQuerZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((AufQuerZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
            <tr className={`TopBorder${ClassNames(ZweiStarrHochGesamt, 3)}`}>
              <td rowSpan='2'>
                <img src={ZweiStarr} alt='Logo' />
              </td>
              <td className='tooltip'>
                <img src={KraftAufrecht} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Upright : ''}</span>
              </td>
              <td>{SelectedProfileFetched ? EigenZweiStarrHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? VertZweiStarrHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? PunktZweiStarrHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? ZweiStarrHochGesamt() : '0'} mm</td>
              <td>{SelectedProfileFetched ? ZweiStarrHochZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(ZweiStarrHochZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((ZweiStarrHochZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
            <tr className={ClassNames(ZweiStarrQuerGesamt, 3)}>
              <td className='tooltip'>
                <img src={KraftLiegend} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Flat : ''}</span>
              </td>
              <td>{SelectedProfileFetched ? EigenZweiStarrQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? VertZweiStarrQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? PunktZweiStarrQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? ZweiStarrQuerGesamt() : '0'} mm</td>
              <td>{SelectedProfileFetched ? ZweiStarrQuerZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(ZweiStarrQuerZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((ZweiStarrQuerZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className='TopBorder'>
              <th colSpan='9' className='TableTitle AusTitle'>
                {text.DCalc ? text.DCalc.Bend : ''}
              </th>
            </tr>
            <tr className='TopBorder'>
              <td rowSpan='2' className='AusImg'>
                <img src={Senkrecht} alt='Logo' />
              </td>
              <td />
              <td rowSpan='2' colSpan='2'>
                <TextField
                  label='b (mm)'
                  type='number'
                  value={b}
                  onChange={handleb}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                />
              </td>
              <td className='tooltip'>
                <img src={KraftAufrecht} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Upright : ''}</span>
              </td>
              <td>&Delta;b={SelectedProfileFetched ? SenkStarrHoch() : '0'} mm</td>
              <td>{SelectedProfileFetched ? SenkStarrHochZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(SenkStarrHochZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((SenkStarrHochZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
            <tr>
              <td />
              <td className='tooltip'>
                <img src={KraftLiegend} alt='Logo' />
                <span className='tooltiptext'>{text.DCalc ? text.DCalc.Flat : ''}</span>
              </td>
              <td>&Delta;b={SelectedProfileFetched ? SenkStarrQuer() : '0'} mm</td>
              <td>{SelectedProfileFetched ? SenkStarrQuerZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(SenkStarrQuerZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((SenkStarrQuerZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr className='TopBorder'>
              <th colSpan='9' className='TableTitle TorTitle'>
                {text.DCalc ? text.DCalc.Torsion : ''}
              </th>
            </tr>
            <tr className='TopBorder'>
              <td>
                <img src={EinDrehung} alt='Logo' />
              </td>
              <td />
              <td rowSpan='2' colSpan='2'>
                <TextField
                  label='Mt (Nm)'
                  type='number'
                  value={Mt}
                  onChange={handleMt}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  disabled={
                    !!(SelectedProfileFetched && Number.isNaN(parseFloat(SelectedProfile.It)))
                  }
                />
              </td>
              <td rowSpan='2'>
                {SelectedProfileFetched && Number.isNaN(parseFloat(SelectedProfile.It))
                  ? 'Kein It Wert vorhanden'
                  : ''}
              </td>
              <td>{SelectedProfileFetched ? EinDreh() : '0'}&deg;</td>
              <td>{SelectedProfileFetched ? EinDrehZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(EinDrehZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((EinDrehZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
            <tr>
              <td>
                <img src={ZweiDrehung} alt='Logo' />
              </td>
              <td colSpan='4' />
              <td>{SelectedProfileFetched ? ZweiDreh() : '0'}&deg;</td>
              <td>{SelectedProfileFetched ? ZweiDrehZwang() : '0'} N/mm²</td>
              <td className='safety'>
                {SelectedProfileFetched ? SicherheitsfaktorSymbol(ZweiDrehZwang) : ''}
              </td>
              <td>
                {SelectedProfileFetched
                  ? Math.round((ZweiDrehZwang() / SelectedProfile['Rp0,2']) * 100)
                  : '0'}{' '}
                %
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default Calculation;
